import { atCapacity } from '../../lib/workbench-display';

/**
 * Figma A05.7 / A05.7b: "X of N active tasks", one segment per slot. When every slot is taken it turns amber and says
 * where new work goes. Amber, never red: being busy is not an error.
 */
export function CapacityGauge({ active, max }: { active: number; max: number }) {
  const full = atCapacity(active, max);
  const slots = Math.max(max, 1);
  return (
    <div
      className={
        full
          ? 'flex flex-col gap-(--mbm-space-2) rounded-(--mbm-component-radius-gauge) border border-capacity-full-border bg-capacity-full-bg px-(--mbm-space-3-5) py-(--mbm-space-2-5)'
          : 'flex flex-col gap-(--mbm-space-2) rounded-(--mbm-component-radius-gauge) border border-border-line bg-surface-card px-(--mbm-space-3-5) py-(--mbm-space-2-5)'
      }
    >
      <p className="flex items-baseline gap-(--mbm-space-1-5) text-body-small">
        <span className="text-label-medium text-text-primary">
          {active} of {max}
        </span>
        <span className={full ? 'text-capacity-full-label' : 'text-text-secondary'}>
          {full ? 'active · at capacity' : 'active tasks'}
        </span>
      </p>
      <div role="img" aria-label={`${active} of ${max} active tasks`} className="flex flex-wrap gap-(--mbm-space-0-75)">
        {Array.from({ length: slots }, (_, i) => (
          <span
            key={i}
            className={`h-(--mbm-space-1-5) w-(--mbm-size-gauge-segment) rounded-full ${
              i < active ? (full ? 'bg-capacity-full-segment' : 'bg-capacity-segment') : 'bg-capacity-segment-empty'
            }`}
          />
        ))}
      </div>
      {full ? (
        <p className="text-body-small text-capacity-full-text">New work goes to your lead until you free a slot.</p>
      ) : null}
    </div>
  );
}
